import React from 'react';
import { Wrapper } from '..';
import './StoryPartners.scss';

const StoryPartners = (props) => {
  const {
    partnersHeadline,
    partners,
  } = props;
  return (
    <section className="story-partners">
      <Wrapper>
        <div className="container">
          <h2 className="headline">{partnersHeadline.text}</h2>
          <ul className="partners">
            {partners && partners.length > 0 && partners.map((partner) => {
              const {
                partnerName,
                partnerType,
                partnerLink,
              } = partner;
              if (!partnerName.text || !partnerType.text) return null;
              if (!partnerLink || !partnerLink.url) {
                return (
                  <li className="partner" key={`${partnerName.text}`}>
                    <div className="container">
                      <div className="partner-type">
                        <span>{partnerType.text}</span>
                      </div>
                      <div className="partner-name">
                        <span>{partnerName.text}</span>
                        <svg className="icon" viewBox="0 0 21 15" xmlns="http://www.w3.org/2000/svg">
                          <path d="M18.165 6.673H1.195a.85.85 0 0 0 0 1.7h16.927l-4.89 5.193a.841.841 0 0 0-.193.832.864.864 0 0 0 .638.58.882.882 0 0 0 .833-.251l6.26-6.647a.844.844 0 0 0 .228-.532.842.842 0 0 0-.228-.628L14.51.273a.882.882 0 0 0-.833-.252.864.864 0 0 0-.638.58.841.841 0 0 0 .194.833l4.932 5.239z" fillRule="evenodd" />
                        </svg>
                      </div>
                    </div>
                  </li>
                );
              }
              return (
                <li className="partner" key={`${partnerLink.url}-${partnerType.text}`}>
                  <a className="container" href={partnerLink.url} rel="noopener noreferrer" target="_blank">
                    <div className="partner-type">
                      <span>{partnerType.text}</span>
                    </div>
                    <div className="partner-name">
                      <span>{partnerName.text}</span>
                      <svg className="icon" viewBox="0 0 21 15" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.165 6.673H1.195a.85.85 0 0 0 0 1.7h16.927l-4.89 5.193a.841.841 0 0 0-.193.832.864.864 0 0 0 .638.58.882.882 0 0 0 .833-.251l6.26-6.647a.844.844 0 0 0 .228-.532.842.842 0 0 0-.228-.628L14.51.273a.882.882 0 0 0-.833-.252.864.864 0 0 0-.638.58.841.841 0 0 0 .194.833l4.932 5.239z" fillRule="evenodd" />
                      </svg>
                    </div>
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </Wrapper>
    </section>
  );
};

export default StoryPartners;
